// @flow

import * as React from 'react'
import { Col, config, Container, Row } from 'react-awesome-styled-grid'
import UserQuotesSlider from '@components/UserQuotesSlider'
import { colors } from '@components/shared'
import RedeemBlock from '@components/gift/RedeemBlock'
import styled from 'styled-components'
import BackgroundGradient from '@components/BackgroundGradient'

export default function QuotesAndDownloadSection (): React.Node {
  return (
    <ContainerDiv className="container quotes">
      <BackgroundGradient quadrant={2} />
      <Container>
        <Row>
          <Col>
            <UserQuotesSlider
              title={`We give 'em something \n to talk about.`}
              backgroundColor={colors.cobalt}
            />
          </Col>
        </Row>
      </Container>
      <RedeemContainer>
        <RedeemBlock />
      </RedeemContainer>
    </ContainerDiv>
  )
}

const RedeemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ContainerDiv = styled.div`
  position: relative;
  overflow: hidden;

  &.quotes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 70px;
    padding-bottom: 70px;
    ${(props: any): string => config(props).media.sm`
      padding-top: 80px;
      padding-bottom: 80px;
    `}
    ${(props: any): string => config(props).media.md`
      padding-top: 80px;
      padding-bottom: 80px;
    `}
    ${(props: any): string => config(props).media.lg`
      padding-top: 100px;
      padding-bottom: 100px;
    `}
    ${(props: any): string => config(props).media.xl`
      padding-top: 120px;
      padding-bottom: 120px;
    `}
  }
`
